export const userConstants = {
	GET_PERMISSIONS_REQUEST: "GET_PERMISSIONS_REQUEST",
	GET_PERMISSIONS_SUCCESS: "GET_PERMISSIONS_SUCCESS",
	GET_PERMISSIONS_ERROR: "GET_PERMISSIONS_ERROR",
	PREVENT_LOAD_PERMISSIONS: "PREVENT_LOAD_PERMISSIONS",

	SET_SESSION_IS_EXPIRED: "SET_SESSION_IS_EXPIRED",

	LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
	LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
	LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

	FORGOT_PASSWORD_REQUEST: "USERS_FORGOT_PASSWORD_REQUEST",
	FORGOT_PASSWORD_SUCCESS: "USERS_FORGOT_PASSWORD_SUCCESS",
	FORGOT_PASSWORD_FAILURE: "USERS_FORGOT_PASSWORD_FAILURE",

	RESET_PASSWORD_REQUEST: "USERS_RESET_PASSWORD_REQUEST",
	RESET_PASSWORD_SUCCESS: "USERS_RESET_PASSWORD_SUCCESS",
	RESET_PASSWORD_FAILURE: "USERS_RESET_PASSWORD_FAILURE",

	LOGOUT: "USERS_LOGOUT",

	VERIFY_CODE_REQUEST: "USERS_VERIFY_CODE_REQUEST",
	VERIFY_CODE_SUCCESS: "USERS_VERIFY_CODE_SUCCESS",
	VERIFY_CODE_FAILURE: "USERS_VERIFY_CODE_FAILURE",

	SET_USER_PROFILE_NAME: "SET_USER_PROFILE_NAME",
};
